// AUTO-GENERATED SQL Builder (V40 Final) for Waitlist
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class WaitlistSql {
  private ast = new SqlAst('Waitlist', 'waitlist');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringId: SqlField;
  public waitOn: SqlField;
  public eventSessionId: SqlField;
  public customerId: SqlField;
  public position: SqlField;
  public status: SqlField;
  public claimExpiresOn: SqlField;
  public createdByUser: SqlNavHybrid;
  public customer: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('waitlist', 'guid', '', 'id', 'waitlist_guid');
    this.offeringId = new SqlField('waitlist', 'offeringId', 'offering', 'id', 'waitlist_offering');
    this.waitOn = new SqlField('waitlist', 'waitOn', '', 'id', 'waitlist_waitOn');
    this.eventSessionId = new SqlField('waitlist', 'eventSessionId', 'eventSession', 'id', 'waitlist_eventSession');
    this.customerId = new SqlField('waitlist', 'customerId', 'customer', 'id', 'waitlist_customer');
    this.position = new SqlField('waitlist', 'position', '', 'id', 'waitlist_position');
    this.status = new SqlField('waitlist', 'status', '', 'id', 'waitlist_status');
    this.claimExpiresOn = new SqlField('waitlist', 'claimExpiresOn', '', 'id', 'waitlist_claimExpiresOn');
    this.createdByUser = createNavHybrid('waitlist', 'waitlist_createdByUser', 'User');
    this.customer = createNavHybrid('waitlist', 'waitlist_customer', 'Customer');
    this.eventSession = createNavHybrid('waitlist', 'waitlist_eventSession', 'EventSession');
    this.offering = createNavHybrid('waitlist', 'waitlist_offering', 'Offering');
    this.updatedByUser = createNavHybrid('waitlist', 'waitlist_updatedByUser', 'User');
    this.id = new SqlField('waitlist', 'id', '', 'id', 'waitlist_id');
    this.isDeleted = new SqlField('waitlist', 'isDeleted', '', 'id', 'waitlist_isDeleted');
    this.createdBy = new SqlField('waitlist', 'createdBy', '', 'id', 'waitlist_createdBy');
    this.createdDate = new SqlField('waitlist', 'createdDate', '', 'id', 'waitlist_createdDate');
    this.updatedBy = new SqlField('waitlist', 'updatedBy', '', 'id', 'waitlist_updatedBy');
    this.updatedDate = new SqlField('waitlist', 'updatedDate', '', 'id', 'waitlist_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:WaitlistSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:WaitlistSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:WaitlistSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:WaitlistSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:WaitlistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:WaitlistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:WaitlistSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:WaitlistSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:WaitlistSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:WaitlistSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
